export default customElements.define('w-speech-box', class SpeechBox extends wealthify.CustomElementBaseClass {

    constructor () {
        const config = {
            styleSelector: 'c-speech-box',
            templateHTML: `
                <div class="c-speech-box" data-root>
                    <div class="c-speech-box__tail" data-tail></div>
                </div>`,
            hasChildren: true,
            cacheDom: [ 'data-tail' ]
        };

        super(config);
    }

    static get validPositions () {
        return [ 'top', 'right', 'bottom', 'left' ];
    }

    static get observedProps () {
        return [
            new wealthify.Prop('tailoffset', {
                default: 50,
                type: wealthify.propTypes.Number(),
                validators: [wealthify.propValidators.IsPercent()]
            }),
            new wealthify.Prop('tailoffsetcustom'),
            new wealthify.Prop('tailposition', {
                default: 'top',
                type: wealthify.propTypes.ArrayItem(this.validPositions)
            }),
            wealthify.props.DarkMode()
        ];
    }

    get propCallbacks () {
        return {
            tailoffset: (value) => {
                this._updateTailOffset(value);
            },
            tailoffsetcustom: (value) => {
                this._updateTailOffset(value);
            },
            tailposition: (value) => {
                this.constructor.validPositions.forEach((position) => {
                    this.dom.root.classList.remove(`${this.styleSelector}--${position}`);
                    this.dom.tail.classList.remove(`${this.styleSelector}__tail--${position}`);
                });
                this.dom.root.classList.add(`${this.styleSelector}--${value}`);
                this.dom.tail.classList.add(`${this.styleSelector}__tail--${value}`);

                this._updateTailOffset();
            },
        };
    }

    _updateTailOffset (value = this.tailoffset) {
        if (this.tailposition === undefined || this.tailoffset === undefined) {
            return;
        }

        if (value <= 5) {
            value = 5;
        } else if (value >= 95) {
            value = 95;
        }
        
        const offset = this.tailoffsetcustom ? this.tailoffsetcustom : value;
        const unit = this.tailoffsetcustom ? '' : '%';
        const isVertical = this.tailposition === 'top' || this.tailposition === 'bottom';
        const positionStyleToChange = isVertical ? 'left' : 'top';
        
        this.dom.tail.style[positionStyleToChange] = `${offset}${unit}`;
        
        if (!this.tailoffsetcustom) {
            const translateStyleToChange = isVertical ? 'translateX' : 'translateY';

            this.dom.tail.style.transform = `${translateStyleToChange}(-50%)`;
        }
    }

});